// Firmanın pasife alma / aktif etme geçmişi
import { useEffect, useState } from 'react';
import axios from 'axios';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { Ban, CheckCircle2, Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const fmtDay = (d) => (d ? d.split('-').reverse().join('.') : '');
const fmtDateTime = (iso) => new Date(iso).toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });

export const PassiveHistoryList = ({ companyId, compact = false }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    axios.get(`${API}/companies/${companyId}/passive-history`).then(r => setItems(r.data)).catch(() => setItems([]));
  }, [companyId]);

  if (items === null) return <div className="flex justify-center py-3"><Loader2 className="h-4 w-4 animate-spin text-slate-400" /></div>;
  if (!items.length) return <p className="text-xs text-slate-400 py-2" data-testid="passive-history-empty">Henüz pasiflik kaydı yok</p>;
  return (
    <ol className={`space-y-2 overflow-y-auto ${compact ? 'max-h-40' : 'max-h-[60vh]'}`} data-testid="passive-history-list">
      {items.map((h, i) => {
        const passive = h.action === 'passive';
        if (h.action === 'until_changed') {
          return (
            <li key={i} className="rounded-lg border border-amber-100 bg-amber-50/50 p-3 text-xs" data-testid={`passive-history-item-${i}`}>
              <div className="flex items-center gap-1.5 font-medium text-amber-800">Pasiflik süresi değiştirildi<span className="ml-auto text-slate-400 font-normal">{fmtDateTime(h.at)}</span></div>
              <p className="text-slate-600 mt-1">İşlemi yapan: {h.by || '-'}</p>
              <p className="text-slate-600">{h.old_until ? fmtDay(h.old_until) : 'Süresiz'} → {h.until ? fmtDay(h.until) : 'Süresiz'}</p>
            </li>
          );
        }
        return (
          <li key={i} className={`rounded-lg border p-3 text-xs ${passive ? 'border-rose-100 bg-rose-50/50' : 'border-emerald-100 bg-emerald-50/50'}`} data-testid={`passive-history-item-${i}`}>
            <div className="flex items-center gap-1.5 font-medium">
              {passive ? <Ban className="h-3.5 w-3.5 text-rose-600" /> : <CheckCircle2 className="h-3.5 w-3.5 text-emerald-600" />}
              <span className={passive ? 'text-rose-700' : 'text-emerald-700'}>{passive ? 'Pasife alındı' : (h.auto ? 'Otomatik aktif edildi (süre doldu)' : 'Aktif edildi')}</span>
              <span className="ml-auto text-slate-400 font-normal">{fmtDateTime(h.at)}</span>
            </div>
            <p className="text-slate-600 mt-1">İşlemi yapan: {h.by || '-'}</p>
            {passive && <p className="text-slate-600">Süre: {h.until ? `${fmtDay(h.until)} tarihine kadar` : 'Süresiz'}</p>}
            {passive && h.reason && <p className="text-slate-800 mt-1">Açıklama: {h.reason}</p>}
            {h.permits?.length > 0 && <p className="text-slate-500 mt-1">Talepler: {h.permits.join(', ')}</p>}
          </li>
        );
      })}
    </ol>
  );
};

export const PassiveHistoryDialog = ({ company, onClose }) => (
  <Dialog open={!!company} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-lg" data-testid="passive-history-dialog">
      <DialogHeader>
        <DialogTitle>Pasiflik Geçmişi — {company?.name}</DialogTitle>
        <DialogDescription>Firmanın pasife alınma ve aktif edilme kayıtları</DialogDescription>
      </DialogHeader>
      {company && <PassiveHistoryList companyId={company.id} />}
    </DialogContent>
  </Dialog>
);
